import React from "react";

export const Loader = ({message}) => {
	return (
		<div className="d-flex align-items-center">
			<div className="spinner-border text-success" role="status">
				<span className="sr-only"></span>
			</div>
      <div className="mx-2">{message}</div>
		</div>
	);
};